import "./Home.module.css";
import GlobalLogisticsHeader from "@/reusable_sections/Header";
import EmpoweringEducationalExcellence from "./sections/EmpoweringEducationalExcellence";
import IndustryFootprint from "./sections/IndustryFootprint";
import OurRoofingExpertise from "./sections/OurRoofingExpertise";
import TheLgJourney from "./sections/TheLgJourney";
import SuccessStories from "./sections/SuccessStories";
import LetsCollaborate from "./sections/LetsCollaborate";
import ClinicFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GlobalLogisticsHeader />
      <EmpoweringEducationalExcellence />
      <IndustryFootprint />
      <OurRoofingExpertise />
      <TheLgJourney />
      <SuccessStories />
      <LetsCollaborate />
      <ClinicFooter />
    </div>;
}